import { httpGet, httpPost } from "@eres/rest";
import cfg from "./config";
import { MQBank, MQReference, MQRequest } from "./entities";

export function getAllBanks(): Promise<MQBank[]> {
	return httpGet( `${ cfg.mortgageQuotationAPI().endPoint() }mortgagee/` );
}

export function submitRequest( request: any ): Promise<MQReference[]> {
	return httpPost( `${ cfg.mortgageQuotationAPI().endPoint() }mortgage/`, request );
}

export function getRequests( requesterId: number ): Promise<MQRequest[]> {
	return httpGet( `${ cfg.mortgageQuotationAPI().endPoint() }mortgage/?requestorId=${ requesterId }` );
}
